import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';
import type {
  WidgetConfigEntry,
  WidgetPropsType,
} from '@agentselly/immodossier-shared';

const baseRegionWidgets: WidgetConfigEntry[] = [
  { name: 'priceHubbleMap', cols: 12 },
  { name: 'nearObjects', cols: 12 },
];

export const regionWidgets = (
  widgetProps: WidgetPropsType = {},
): WidgetConfigEntry[] => {
  const isV3 = Boolean(
    (widgetProps?.priceHubbleMap as any)?.v3Redesign ??
      (widgetProps as any)?.v3Redesign,
  );
  const activeWidgets = isV3
    ? baseRegionWidgets
    : baseRegionWidgets.filter((w) => w.name !== 'priceHubbleMap');
  return makeDynamicConfigWidgets(activeWidgets)(widgetProps);
};
